export function setActiveInputValue(value, isAutocomplete) {
    return (
        window['priTextBox'] &&
        window['priTextBox'].setInputValue &&
        window['priTextBox'].setInputValue(value, isAutocomplete)
    );
}

export function getFieldText() {
    return (
        window['priTextBox'] &&
        window['priTextBox'].getFieldText &&
        window['priTextBox'].getFieldText()
    );
}

export function getFieldName() {
    return (
        window['priTextBox'] &&
        window['priTextBox'].getFieldName &&
        window['priTextBox'].getFieldName()
    );
}

export function getFieldTitle() {
    return (
        window['priTextBox'] &&
        window['priTextBox'].getFieldTitle &&
        window['priTextBox'].getFieldTitle()
    );
}

export function getRelatedFieldValue() {
    return (
        window['priTextBox'] &&
        window['priTextBox'].getRelatedFieldValue &&
        window['priTextBox'].getRelatedFieldValue()
    );
}

export function getRelatedIdFieldName() {
    return (
        window['priTextBox'] &&
        window['priTextBox'].getRelatedIdFieldName &&
        window['priTextBox'].getRelatedIdFieldName()
    );
}

export function getFieldOrigValue() {
    return (
        window['priTextBox'] &&
        window['priTextBox'].getFieldOrigValue &&
        window['priTextBox'].getFieldOrigValue()
    );
}

export function executeTabKey(shiftKey) {
    window['priTextBox'] &&
        window['priTextBox'].executeTabKey &&
        window['priTextBox'].executeTabKey(shiftKey);
}

export function getDecimalSign(): string {
    const decimalSign = window['priTextBox']?.getDecimalSign?.();
    return String.fromCharCode(decimalSign);
}

export function getThousandSign(): string {
    const thousandSign = window['priTextBox']?.getThousandSign?.();
    return String.fromCharCode(thousandSign);
}

export function onHyperlinkClick(linkData) {
    window['priTextBox'] &&
        window['priTextBox'].onHyperlinkClick &&
        window['priTextBox'].onHyperlinkClick(linkData);
}

export function setInputValueByColName(value, id) {
    return (
        window['priTextBox'] &&
        window['priTextBox'].setInputValueByColName &&
        window['priTextBox'].setInputValueByColName(value, id)
    );
}
